import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'motn-sharing',
    templateUrl: './sharing.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./sharing.component.scss'],
})
export class SharingComponent implements OnInit {

  constructor() {
  }


  ngOnInit(): void {
  }

}
